import { validators } from '../../utils/validators';

const findTransactionFormValidator = values => {

    const { REQUIRE } = validators;
    const errors = {};

    if (REQUIRE(values?.identifier)) {
        errors.identifier = `Please enter ${values?.searchParameter}`;
    }
    if(REQUIRE(values?.dispute_type)){
        errors.dispute_type = `Please Select Valid Dispute Type`;
    }

    return errors;
};


const raiseChargebackFormValidator = values => {

    const { REQUIRE } = validators;
    const errors = {};

    if (REQUIRE(values?.reasonCode)) {
        errors.reasonCode = `Please select reason code`;
    }


    if (REQUIRE(values?.rrnNumber)) {
        errors.rrnNumber = `Please select RRN Number`;
    }


    if (REQUIRE(values?.reportedDate)) {
        errors.reportedDate = `Please Select reported Date`;
    }


    // if (!values.files || values.files.length <= 0) {
    //     errors.files = `Please enter atlease in file`;
    // }


    return errors;
};



export { raiseChargebackFormValidator, findTransactionFormValidator };
